import { ReactNode, useEffect } from "react";

import "./modal.css";

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    title?: string;
    closeOnOverlayClick?: boolean;
    children: ReactNode;
}

export default function Modal({
    isOpen,
    onClose,
    title,
    closeOnOverlayClick = true,
    children
}: ModalProps) {
    useEffect(() => {
        if (!isOpen) return;

        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === "Escape") {
                onClose();
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div
            className="modal-overlay"
            onClick={e => {
                if (closeOnOverlayClick) onClose();
                else e.stopPropagation();
            }}
            role="presentation"
        >
            <div
                className="modal-content"
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
                aria-label={title ?? "Modal"}
            >
                {title && <h2 className="modal-title">{title}</h2>}
                <button
                    type="button"
                    className="modal-close"
                    onClick={onClose}
                    aria-label="Close modal"
                >
                    x
                </button>
                <div className="modal-body">{children}</div>
            </div>
        </div>
    );
}
